export enum AccountType {
  Admin = 1,
  Affiliation = 2,
  PageA = 3,
  PageB = 4,
  PageC = 5,
  SubAdmin = 6,
  Employee = 7,        // لو موجود عندك
  DeliveryHero = 8,    // لو موجود
  Client = 9,
  SuperAdmin = 10
}
